import config from 'src/config';
import api from 'src/services/httpService';

class Auth {
  static signIn({ email, password }) {
    return api.post(`${config.rootUrl}/auth/admin/signin`, {
      email,
      password
    });
  }

  static signup(data) {
    return api.post(`${config.rootUrl}/auth/admin/signup`, data);
  }

  static forgotPassword(email) {
    return api.post(`${config.rootUrl}/auth/admin/forgot`, { email });
  }

  static logout(refreshToken) {
    return api.post(`${config.rootUrl}/auth/logout`, { refreshToken });
  }

  static resetPassword(data) {
    return api.post(`${config.rootUrl}/auth/admin/reset`, data);
  }
}

export default Auth;
